export function RootSSO() {
	const route = process.env.REACT_APP_SSO_URL; //"http://localhost:3333";
	return route;
}

export function RootDeskApis() {
	const route = process.env.REACT_APP_APIS_URL; //"http://localhost:3337";
	return route;
}
